<template>
  <div class="promo">

    <div class="left" :style="backgroundColor">
      <div class="category">{{ data.category }}</div>
      <div class="page-content">
        <SectionContent class="new" @prev="prev" @next="next" :content="content_1" :arrows="!isOneSection" />
        <SectionContent class="old" @prev="prev" @next="next" :content="content_2" :arrows="!isOneSection"/>
      </div>
    </div>

    <div :class="[(sidebarColor ? 'background' :'not-background'), 'right']">
      <div class="section-title">
        {{ data.title }}
      </div>  
      <div class="sections">
         <component
          class="section-item"
          :ref="'section_' + index"
          v-if="data.sections"
          v-for="(section, index) in data.sections"
          :index="index"
          :isCurrent="isCurrent(index)"
          :isDisActive="isDisActive"
          :data="section"
          :is="section.bundle"
          @setCurrent="setCurrent"
          @setContent="setContent"
          />
          <div id="blob"></div>
      </div>
    </div>

  </div>
</template>

<script>
import { SET_COLOR_SIDEBAR } from '../../store'
import completeLoad from '../../mixins/completeLoad'
import { TweenMax } from "gsap/TweenMax";
import $ from "jquery";

import component_section from '../../components/Sections/Section.vue'
import component_icon_section from '../../components/Sections/IconsSection.vue'
import SectionContent from '../../components/Sections/SectionContent.vue'

export default {
  props: [
    'data',
  ],

  data () {
    return {
      key: 0,
      dir: 'fade',
      content_1: {
        html: '',
        image: null
      },
      content_2: {
        html: '',
        image: null
      },
      disable: false,
      link: null,
      color: null,
      image: null,
      items: []
    }
  },

  mixins: [completeLoad],

  components: {
    component_section,
    component_icon_section,
    SectionContent
  },

  created () {
    this.$store.commit(SET_COLOR_SIDEBAR, this.data.sidebar_background)

    for (let key in this.data.sections) {
      if ($(window).width() < 1018 && this.data.sections[key].background_mobile) {
        this.imageLoad(this.data.sections[key].background_mobile)
      } else {
        this.imageLoad(this.data.sections[key].background)
      }
      if (this.$route.hash == this.data.sections[key].hash) {
        this.key = key
      }
    }

    this.animRun()
  },

  mounted () {
    this.$nextTick(function () {
      this.$nextTick(function () {
        this.updateContentHeight($('.new'))
        this.toActiveSection()
        this.addEventMoveSections()
      })
    })

    $(window).on('resize', () => {
        this.updateContentHeight($('.old'))
        var active = this.getActiveSection()
        if (active) {
          $('#blob', $(this.$el)).height(active.outerHeight())
          $('#blob', $(this.$el)).css('top', active.position().top)
        }
    });
  },

  computed: {
    sidebarColor () {
      return this.$store.state.sidebarColor
    },

    backgroundColor () {
      return this.color ? 'background-color: ' + this.color : ''
    },

    isDisActive () {
      return this.disable || this.data.sections.length <= 1
    },

    isOneSection () {
      return this.data.sections.length <= 1
    }
  },

  methods: {
    getActiveSection () {
      return $('.section-item.active', $(this.$el))
    },

    toActiveSection () {
      var active = this.getActiveSection()
      $('#blob', $(this.$el)).animate({
        top : active.position().top,
        height : active.outerHeight()
      }, 500)
    },

    addEventMoveSections () {
      let blob = $('#blob', $(this.$el))
      var self = this

      $('.sections', this.$el).hover(function() {}, function() {
        var active = self.getActiveSection()
        blob.animate({
          top : active.position().top,
          height : active.outerHeight()
        }, 500)
      })

      $('.section-item', this.$el).hover(function() {
        blob.animate({
          top : $(this).position().top,
          height : $(this).outerHeight()
        },{
          duration : 500,
          queue : false
        });
      });
    },

    updateContentHeight (el) {
      var height = $(window).width() > 1018 ? '100%' : $('.body', el).height() + 'px'
      $('.left .page-content').css('height', height)
    },

    backToActive () {
      var active = $('.section-item.active', $(this.$el));
      if (!active.length) { return }
      $('#blob', $(this.$el)).animate({
        top : active.position().top,
        height : active.outerHeight()
      }, 500)
    },

    stopIframes (content) {
      let iframe = $('iframe', content)

      if (iframe.length > 0) {
        iframe.attr('src', iframe.attr('src')); 
      }
    
    },

    animRun (change) {
      let old = $(this.$el).find('.page-content .old')
      let nw = $(this.$el).find('.page-content .new')

      if (!change) {
        this.updateVisualContent(old)
        return
      }

      this.categoryOpacity(0)

      TweenMax.to(old, 1, { opacity: 0, left: '100%', ease: Power1.easeInOut, onComplete: (arg) => {
        old.removeClass('old').addClass('new').removeAttr('style').find('.text').scrollTop(0) 
        this.stopIframes(old)
      }})

      TweenMax.to(nw, 1, { opacity: 1, left: 0, ease: Power1.easeInOut, onComplete: (arg) => {
        nw.removeClass('new').addClass('old')
        this.updateVisualContent(nw)
      }})
    },

    updateVisualContent (el) {
      this.updateContentHeight(el)
      this.disable = false
      this.categoryOpacity(1)
      this.backToActive()
      this.fxLogo()
    },

    categoryOpacity (opacity) {
      TweenMax.to($(this.$el).find('.category'), 0.2, { opacity: opacity, ease: Power1.easeInOut })
    },

    setCurrent (key) {
      if (this.disable) {
        return
      }

      this.dir = this.key < key ? 'next' : 'prev'
      this.key = key
    },

    setBackground (background, change) {
      this.disable = true

      this.changeBackground(background, this.dir, () => {
          this.animRun(change)
      })
    },

    setContent (content) {
      if (this.disable) {
        return
      }

      this.toTop()
      let change = true

      if (!this.content_1.current && !this.content_2.current) {
        this.content_2 = Object.assign({ current: true }, content);
        this.content_1.current = false
        change = false
      } else if (this.content_1.current) {
        this.content_2 = Object.assign({ current: true }, content);
        this.content_1.current = false
      } else {
        this.content_1 = Object.assign({ current: true }, content);
        this.content_2.current = false
      }

      this.link = content.link
      this.color = content.color
      this.setBackground(content.background, change)
    },

    isCurrent (index) {
      return index == this.key
    },

    prev () {
      if (this.disable) {
        return
      }

      let isIconsPrev = this.$refs['section_' + this.key][0].prev();
      let max = this.data.sections.length - 1

      if (this.key === 0 && !isIconsPrev) {
        if (this.data.sections[max].bundle === 'component_icon_section') {
          this.$refs['section_' + max][0].setCacheMax()
        }

        this.setCurrent(max)
      } else if (!isIconsPrev) {
        this.setCurrent(this.key - 1)
      }
    },

    next () {
      if (this.disable) {
        return
      }

      let isIconsNext = this.$refs['section_' + this.key][0].next();
      let max = this.data.sections.length - 1
      let nextKey = this.key != max ? this.key + 1 : 0

      if (!isIconsNext && this.data.sections[nextKey].bundle === 'component_icon_section') {
       this.$refs['section_' + nextKey][0].setCacheMin()
      } 

      if (this.key == max && !isIconsNext) {
        this.setCurrent(0)
      } else if (!isIconsNext) {
        this.setCurrent(nextKey)
      }
    }
  }
}
</script>

<style lang="scss">
$border: #828282;
$border-active: #56CCF2;

.promo {
  display: flex;
  align-items: center;
  height: 100%;
  .left {
    width: 75%;
    position: relative;
    transition: all .5s ease;
    background-color: transparent;
  }

  .category {
    position: absolute;
    letter-spacing: 1px;
    transform: rotate(-90deg);
    text-transform: uppercase;
    left: -50px;
    font-family: 'Montserrat', sans-serif;
    top: 50%;
    font-size: 14px;
  }

  .right {
    &.background {
      .section-title {
        background-color: rgba(17, 16, 32, 0.75);
        border-bottom: 1px solid $border-active;
        border-left: 1px solid $border-active;
        border-right: 1px solid $border-active;
      }
      .sections {
        .section-item { 
          border-left: 1px solid $border;
          border-right: 1px solid $border;
          border-bottom: 1px solid $border;
          background-color: rgba(17, 16, 32, 0.75);
          &:last-child {
            border-bottom: 0px !important;
          }
          &:first-child {
            border-top: 0px !important;
          }
          &.active {
            border: 1px solid $border-active;
          }
        }
      }
    }
    &.not-background {
     .section-title {
        border-bottom: 1px solid white;
        border-left: 1px solid white;
        border-right: 1px solid white;
      }
      .sections {
        .section-item { 
          border-left: 1px solid white;
          border-right: 1px solid white;
          border-bottom: 1px solid white;
          &:last-child {
            border-bottom: 0px !important;
          }
          &:first-child {
            border-top: 0px !important;
          }
        }
      }
    }
  }

  .right {
    height: 100%;
    width: 25%;
  }

  .section-title {
    color: white;
    padding: 20px;
    display: flex;
    align-items: flex-end;
    font-weight: bold;
    font-size: 18px;
    height: 100px;
  }

  .sections {
    display: flex;
    flex-direction: column;
    height: calc(100% - 100px);
    position: relative;
    #blob {
      position: absolute;
      left: 0px;
      right: 0px;
      background-color: rgba(86, 204, 242, 0.5);
    }
    .section-item {
      z-index: 2;
    }
  }

  .link-buttom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .text {
      text-transform: uppercase;
      font-size: 22px;
      letter-spacing: 2px;
    }
  }

  .page-content {
    position: relative;
    .text {
      width: 100%;
    }
    .old {
      position: absolute !important;
      top: 0px;
      width: 100%;
      left: 0px;
      bottom: 0px;
      z-index: 50;
    }
    .new {
      position: absolute !important;
      left: -100%;
      top: 0px;
      width: 100%;
      opacity: 0;
      bottom: 0px;
      z-index: 50;
    }
  }
}
</style>
